// src/mocks/handlers/auth/protectedEndpointHandler.ts

import { rest } from 'msw';
import { VITE_MSW_BASE_URL } from '@/config';
import { accessTokenExpiry } from '@/mocks/data/tokenTimers';

// ONLY TO TEST THE PROTECTED ENDPOINT
export const protectedEndpointHandler = rest.get(
  `${VITE_MSW_BASE_URL}/protected-endpoint`,
  (req, res, ctx) => {
    const now = Date.now();

    const authHeader = req.headers.get('Authorization');
    if (authHeader === 'Bearer expired_access_token') {
      return res(ctx.status(401));
    }

    if (now > accessTokenExpiry) {
      return res(ctx.status(401), ctx.json({ error: 'Access token expired' }));
    }

    return res(ctx.status(200), ctx.json({ success: true }));
  },
);
